import * as React from 'react';

import {formatTimestampForPinnedEntry} from 'nutshell-core/date-time/formatting';

import type {ThreadType} from 'nutshell-graphql-types';

import {SpacerGroup} from '../../../spacer/spacer-group';
import {Body} from '../../../typography/body';

import {
    TimelineHeaderActionText,
    type Props as TimelineHeaderActionTextProps,
} from './timeline-header-action-text';
import {TimelineHeaderEmailSource} from './timeline-header-email-source';
import TimelineHeaderTimestamp from './timeline-header-timestamp';
import type {PinnedInfo} from './types';

import styles from './timeline-header.module.css';

// TimelineHeaderProps
export type Props = TimelineHeaderActionTextProps & {
    timestamp: number;
    isSmall?: boolean;
    pinnedInfo?: PinnedInfo | null | undefined;
    isPinnedThread?: boolean;
    threadType?: ThreadType;
    subtitleComponent?: React.ReactNode;
    originatedVia?: string | null | undefined;
};

export function TimelineHeader(props: Props) {
    const {
        timestamp,
        isSmall,
        pinnedInfo,
        isPinnedThread,
        threadType,
        subtitleComponent,
        originatedVia,
        ...restProps
    } = props;

    return (
        <div className={isSmall ? styles['header-container--small'] : styles['header-container']}>
            <SpacerGroup mb={isSmall ? 2 : 4}>
                <div className='flex align-center'>
                    {isPinnedThread && <Body size='small'>Most recent message:&nbsp;</Body>}
                    <TimelineHeaderTimestamp timestamp={timestamp} />
                    {originatedVia && <TimelineHeaderEmailSource originatedVia={originatedVia} />}
                    {pinnedInfo ? (
                        <div
                            data-tip={
                                pinnedInfo.pinnedTime
                                    ? `Pinned ${formatTimestampForPinnedEntry(
                                          pinnedInfo.pinnedTime
                                      )}`
                                    : undefined
                            }
                            className={styles.pinned}
                        >
                            (Pinned by {pinnedInfo.pinnedByUser.name})
                        </div>
                    ) : undefined}
                </div>
            </SpacerGroup>
            <TimelineHeaderActionText
                {...restProps}
                isPinnedThread={isPinnedThread}
                threadType={threadType}
            />
            {subtitleComponent && <div className='mt-4 font-size-small'>{subtitleComponent}</div>}
        </div>
    );
}
